import React, { useState } from 'react';
import { Box, Button, TextField, MenuItem } from "@mui/material";
import { updateSearchSettings } from "../API/KB/KBAPI.js";
import { mobileButton } from "../App/theme.js";
import { EmbeddingDimensions } from "../constants";
import { PaperWrapper } from "../Components/PaperWrapper";
import { buttonVerticalMargin } from "../App/style";

const SetupItems = ({ EmbeddingModels, setIsLoading, embeddingModel, embeddingDimension, setEmbeddingDimension, fetchKB, setEmbeddingModel }) => {
    const [searchEngine, setSearchEngine] = useState('IndexedDB');

    const handleUpdateSearchSettings = async () => {
        const dim = embeddingModel && embeddingModel !== 'none' ? embeddingDimension : 'none';
        setIsLoading(true);
        await updateSearchSettings(embeddingModel, dim, searchEngine);
        await fetchKB();
        setIsLoading(false);
    }

    return (
        <>
            <PaperWrapper>
                <Box mt={2} sx={{ width: '100%', marginBottom: '16px' }}>
                    <TextField
                        select
                        label="Search Engine"
                        value={searchEngine}
                        onChange={(e) => setSearchEngine(e.target.value)}
                        fullWidth={true}
                        variant="outlined"
                        SelectProps={{
                            renderValue: (selected) => (
                                <Box display="flex" key={selected}>
                                    {selected === 'IndexedDB' ? 'IndexedDB' : 'OpenSearch'}
                                </Box>
                            )
                        }}
                    >
                        <MenuItem key={'IndexedDB'} value={'IndexedDB'}>
                            IndexedDB - In-browser data storage and search
                        </MenuItem>
                        <MenuItem key={'openSearch'} value={'openSearch'} disabled={true}>
                            OpenSearch - Serverless distributed search and analytics engine ( coming soon )
                        </MenuItem>
                    </TextField>
                </Box>

                <Box mt={2} sx={{ width: '100%', marginBottom: '16px' }}>
                    <TextField
                        select
                        label="Embedding Model"
                        value={embeddingModel || ''}
                        onChange={(model) => {
                            setEmbeddingModel(model?.target?.value);

                            if (model?.target?.value !== 'none') {
                                setEmbeddingDimension(EmbeddingModels[model?.target?.value]?.dimension);
                            }
                        }}
                        fullWidth={true}
                        variant="outlined"
                        SelectProps={{
                            renderValue: (selected) => (
                                <Box display="flex" key={EmbeddingModels[selected]?.name}>
                                    {EmbeddingModels[selected]?.name || 'None'}
                                </Box>
                            )
                        }}
                    >
                        {Object.keys(EmbeddingModels).map((key) => (
                            <MenuItem key={key} value={key}>
                                {EmbeddingModels[key].name}
                            </MenuItem>
                        ))}
                        <MenuItem key={'none'} value={'none'}>
                            None
                        </MenuItem>
                    </TextField>
                </Box>

                {embeddingModel && embeddingModel !== 'none' && <Box mt={2} sx={{ marginTop: '16px', width: '100%', marginBottom: '16px' }}>
                    <TextField
                        select
                        label="Embedding Dimensions"
                        value={embeddingDimension || ''}
                        onChange={(model) => {
                            setEmbeddingDimension(model?.target?.value);
                        }}
                        fullWidth={true}
                        variant="outlined"
                        SelectProps={{
                            renderValue: (selected) => (
                                <Box display="flex" key={selected}>
                                    {selected}
                                </Box>
                            )
                        }}
                    >
                        {EmbeddingDimensions.map((key) => (
                            <MenuItem key={key} value={key}>
                                {key}
                            </MenuItem>
                        ))}
                    </TextField>
                </Box>}

            </PaperWrapper>
            <Box mt={0} display="flex" flexWrap="wrap" justifyContent="flex-end">
                <Button
                    fullWidth={true}
                    onClick={() => handleUpdateSearchSettings()}
                    variant="contained"
                    color="secondary"
                    style={{ ...mobileButton, marginTop: buttonVerticalMargin }}
                >
                    Enable Items API
                </Button>
            </Box>
        </>
    );
}

export default SetupItems;